import store from "../../../../store/store";
import TaskModel from "../../../../models/responses/task.model";

export default function generateDAGData(taskId) {
    const cpmMap = store.getState().project.cpmMap

    let data = new Map()
    let dataArr: any[] = []
    function getParents (id: string) {
        const task = cpmMap.get(id)
        let parents = cpmMap.get(`${id}:preds`).map((pred: string) => {
            const parentLink = cpmMap.get(pred)
            return {parentId: parentLink.pred_task_id, ad: parentLink.ad}
        })
        let parentData: string[] = []
        parents.forEach(parent => {
            if (parent.ad === task.ad) {
                parentData.push(parent.parentId)
                if (!data.has(parent.parentId)) {
                     getParents(parent.parentId)
                }
            }
        })
        data.set(id, {id: id, parentIds: parentData})
        dataArr.push({id: id, parentIds: parentData})
    }

    getParents(taskId)

    return dataArr
}

export function generateAllDAGData(cpmMap: Map<string, any>, project_id: string) {
    const noSuccTasks = cpmMap.get(`end:${project_id}`)

    let data = new Map()
    function getParents (id: string) {
        let parents = cpmMap.get(`${id}:preds`).map((pred: string) => {
            const parentLink = cpmMap.get(pred)
            return  parentLink.pred_task_id
        })
        let parentData: string[] = []
        parents.forEach((parent: string) => {
            parentData.push(parent)
            if (!data.has(parent)) {
                getParents(parent)
            }
        })
        data.set(id, {id: id, parentIds: parentData})
    }

    if (noSuccTasks) {
        noSuccTasks.forEach((taskId: string) => getParents(taskId))
    }

    return Array.from(data.values())
}

export function generateTaskDAGData(taskId, cpmMap) {
    const predecessors  = cpmMap.get(`${taskId}:preds`)
    const successors = cpmMap.get(`${taskId}:succs`)

    let data = new Map()
    let drivingTasks = new Map();
    const mainTask = cpmMap.get(taskId)

    data.set(taskId, {id: taskId, parentIds: predecessors?.map((pred: string) => cpmMap.get(pred).pred_task_id)})
    // drivingTasks.set(taskId, true)

    predecessors?.forEach((pred: string) => {
        const predLink = cpmMap.get(pred)
        if (predLink.ad === mainTask.ad) drivingTasks.set(predLink.pred_task_id, true)
        const predOfPreds = cpmMap.get(`${predLink.pred_task_id}:preds`)
        const predTaskIds = predOfPreds.map((pred: string) => cpmMap.get(pred).pred_task_id)
        const predCpmTask = cpmMap.get(predLink.pred_task_id)
        data.set(predLink.pred_task_id, {id: predLink.pred_task_id, parentIds: predTaskIds})
        predTaskIds.forEach((predOfPred: string, i: number) => {
            const taskInData = data.get(predOfPred)
            const predOfPredLink = cpmMap.get(`${predOfPreds[i]}`)
            if (predOfPredLink.ad === predCpmTask.ad) drivingTasks.set(predOfPred, true)
            if (taskInData) {
                data.set(predOfPred, {id: predOfPred, parentIds: taskInData.parentIds})
            } else {
                data.set(predOfPred, {id: predOfPred, parentIds: []})
            }
        })
    })

    successors?.forEach((succ: string) => {
        const succLink = cpmMap.get(succ)
        if (succLink.af === mainTask.af) drivingTasks.set(taskId, true)
        const succsOfSuccs = cpmMap.get(`${succLink.task_id}:succs`)
        const succsTaskIds = cpmMap.get(`${succLink.task_id}:succs`).map((succ: string) => cpmMap.get(succ).task_id)
        const succCpmTask = cpmMap.get(succLink.task_id)
        data.set(succLink.task_id, {id: succLink.task_id, parentIds: [taskId]})
        succsTaskIds.forEach((succOfSucc: string) => {
            const taskInData = data.get(succOfSucc)
            const succOfSuccLink = cpmMap.get(`${succsOfSuccs[0]}`)
            if (succOfSuccLink.af === succCpmTask.af) drivingTasks.set(succLink.task_id, true)
            if (taskInData) {
                data.set(succOfSucc, {id: succOfSucc, parentIds: [...taskInData.parentIds, succLink.task_id]})
            } else {
                data.set(succOfSucc, {id: succOfSucc, parentIds: [succLink.task_id]})
            }
        })
    })

    return {dagData: Array.from(data.values()), drivingTasks}
}

export function addMoreToDag(node: any, previousNode: any, cpmMap: Map<string, any>, dagData: any[]) {
    const direction = node.data.uy < previousNode.data.uy ? 'left' : 'right'

    if (direction === 'left') {
        const predecessors  = cpmMap.get(`${node.data.id}:preds`)
    }

}